import React from "react";
// If you're using react-router-dom, uncomment the next line and replace the <a> tag with <Link>
// import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100"
      style={{ background: "linear-gradient(135deg, #f6d365, #fda085)" }}
    >
      <div
        className="text-center text-white"
        style={{ textShadow: "1px 1px 2px rgba(0, 0, 0, 0.2)" }}
      >
        <h1 className="display-1 fw-bold">404</h1>
        <p className="lead">
          Oops! You've wandered into the Bermuda Triangle of the internet.
        </p>
        <p>
          The page you’re looking for might be out on a coffee break or hiding
          with your missing socks.
        </p>
        {/* If using react-router-dom, replace <a> with <Link to="/"> */}
        <a href="/" className="btn btn-light mt-3">
          Take Me Home
        </a>
      </div>
    </div>
  );
};

export default NotFoundPage;
